module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/main-97958d3b70b267decb9a3755e0e9939d.png";